import { request } from '../axios/request';

import {
  FETCH_PACKAGE_ORDER_DETAIL_PENDING,
  FETCH_PACKAGE_ORDER_DETAIL_REJECTED,
  FETCH_PACKAGE_ORDER_DETAIL_FULFILLED,
  SET_PACKAGE_ORDER_DETAIL_SELECTED_IDS,
} from '../constants/packageOrderDetail';

const OMS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_PACKAGE_ORDER_DETAIL_PENDING,
});

const fulfilled = (data) => ({
  type: FETCH_PACKAGE_ORDER_DETAIL_FULFILLED,
  data,
});

const rejected = (error) => ({
  type: FETCH_PACKAGE_ORDER_DETAIL_REJECTED,
  error,
});

export const _setPackageOrderDetailSelectedIds = (data) => ({
  type: SET_PACKAGE_ORDER_DETAIL_SELECTED_IDS,
  data,
});

export const fetchPackageOrderDetail = (packageOrderId) => (dispatch) => {
  dispatch(pending());

  const url = OMS.OMS.PACKAGE_ORDER_DETAIL.replace('{0}', packageOrderId);
  request({ method: 'get', url })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected({ apiError: error }));
    });
};

export const setPackageOrderDetailSelectedIds = (data) => (dispatch) => {
  dispatch(_setPackageOrderDetailSelectedIds(data));
};



// WEBPACK FOOTER //
// ./src/actions/packageOrderDetail.js